import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Empresa } from 'src/model/empleado';
import { ToolsProvider } from 'src/app/provider/tools/tools';
import { BaseUrl } from 'src/app/service/Configuration';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-filtro-busqueda',
  templateUrl: './filtro-busqueda.component.html',
  styleUrls: ['./filtro-busqueda.component.scss'],
})
export class FiltroBusquedaComponent implements OnInit {
  EmpresaTmp =''
  Bajatmp = false
  empresa: Empresa [];
  EmpresaSelect='';
  Baja:boolean
  constructor(public http: HttpClient,public tool:ToolsProvider, private popoverCtrl:PopoverController) { }

  ngOnInit() {
    this.tool.showLoader()
    this.getEmpresa()
    this.Baja= this.Bajatmp
    this.EmpresaSelect = this.EmpresaTmp
  }

  public getEmpresa() {
    this.http.get(BaseUrl+'api/getEmpresa').subscribe((Response:any)=>{
      this.empresa=Response
      this.tool.hideLoader()
    },err=>{
      var error = err.error;
      var error2 = err.message;
      if (error.type != undefined) {
        error = error2
      }
      this.tool.hideLoader()
      this.tool.showAlert('ERROR',''+ 'Ha ocurrido un error<br>'+error)
  });
  }

  Aceptar(){
    if(this.EmpresaSelect === undefined) {this.EmpresaSelect = ''}
    else if(this.EmpresaSelect !== undefined || this.Baja !== false){ 
      this.EmpresaTmp=this.EmpresaSelect
      this.Bajatmp= this.Baja
    }
    this.popoverCtrl.dismiss({'Empresa': this.EmpresaSelect, 'verBaja':this.Baja})
  }

  Limpiar(){
    this.EmpresaSelect =''
    this.Baja = false
    this.EmpresaTmp =''
    this.Bajatmp = false
    this.popoverCtrl.dismiss({'Empresa': this.EmpresaSelect, 'verBaja':this.Baja})
  }

  onChange(event, id:number){
    if(id ===1){
      this.Baja=event.detail.checked
      // this.Bajatmp=event.detail.checked
    }else{
      this.EmpresaSelect=event.detail.value
    }
  }
}
